import { render, staticRenderFns } from "./statementManagementY.vue?vue&type=template&id=5c8f696a&scoped=true"
import script from "./statementManagementY.vue?vue&type=script&lang=js"
export * from "./statementManagementY.vue?vue&type=script&lang=js"
import style0 from "./statementManagementY.vue?vue&type=style&index=0&id=5c8f696a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f696a",
  null
  
)

export default component.exports